<template>
  <article v-if="bookLoaded" class="book-thumb">
    <RouterLink
      class="book-thumb-link"
      :to="{ name: 'book', params: { bookSlug } }"
    >
      <DynCdnPicture
        class="cover-picture"
        :width="300"
        :height="425"
        :picture-id="bookData.coverPicture.id"
      />
      <h3 class="book-name">
        {{ bookData.name }} <TextToSpeech :text="bookData.name" />
      </h3>
      <p v-if="hasLevelData" class="book-class-level">{{ levelClassName }}</p>
      <loading-animation v-else />
    </RouterLink>

    <Accordion :open="false">
      <template slot="header">{{ $t('buttons.info') }}</template>
      <div v-html="bookData.description" />
    </Accordion>
  </article>
  <LoadingAnimation v-else />
</template>

<script>
import Accordion from '../ui/Accordion'
import DynCdnPicture from '../media/DynCdnPicture'
import LoadingAnimation from '../LoadingAnimation'
import TextToSpeech from '@/components/accessibility/TextToSpeech'
import { createSlug } from '../../utils/string'

export default {
  name: 'BookThumb',
  components: {
    Accordion,
    DynCdnPicture,
    LoadingAnimation,
    TextToSpeech,
  },
  props: {
    bookData: Object,
    hasLevelData: { type: Boolean, default: false },
    levelClassName: String,
  },
  computed: {
    /**
     * @returns {boolean}
     */
    bookLoaded() {
      return this.bookData !== null && this.bookData !== undefined
    },

    /**
     * @returns {string}
     */
    bookSlug() {
      return createSlug(this.bookData.name, this.bookData.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.book-thumb-link {
  text-decoration: none;
}

.element-toggle-button-wrapper {
  margin: 0.4em 0 0;
}

.book-name,
.book-class-level {
  margin: 0;
  color: $textColor;
}

.book-name {
  .text-to-speech {
    vertical-align: 5%;
  }
}

::v-deep .accordion {
  .header {
    font-size: 1em;
  }
  .header,
  .body-inner {
    padding: 0;
  }
}

.cover-picture {
  margin-bottom: 0.7em;
  box-shadow: 0 0.1em 0.7em rgba(0, 0, 0, 0.5);
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 0.1em 0.9em rgba(0, 0, 0, 0.7);
  }
}
</style>
